import { Button, Table } from "antd";

export const FleetTable = ({fleetList, fleetVehicleModalOpenFun}) => {

  const columns = [
    {
      title: "ID",
      dataIndex: "fleetId",
      key: "fleetId",
    },
    {
      title: "Name",
      dataIndex: "fleetName",
      key: "fleetName",
    },
    // {
    //   title: "Org",
    //   dataIndex: "org",
    //   key: "org",
    //   render: (orgs) => orgs?.map((org) => org).join(", "),
    // },
    {
      title: "Vehicle IMEI",
      dataIndex: "vehicleImei",
      key: "vehicleImei",
      render: (ids) => ids?.map((id) => id).join(", "),
    },
    // {
    //   title: "Description",
    //   dataIndex: "description",
    //   key: "description",
    // },
    // {
    //   title: "Status",
    //   dataIndex: "status",
    //   key: "status"
    // },
    {
      title: "Action",
      dataIndex: "act",
      key: "act",
      align: "center",
      render: (_,record) => (
        <Button type="primary" className="add-fleet-vehicle-btn" onClick={() => fleetVehicleModalOpenFun(record)}>
          {"Modify Vehicles"}
        </Button>
      ),
    },
  ];

  return (
    <Table
      columns={columns}
      rowKey={(record) => record.fleetId}
      dataSource={fleetList}
      pagination={fleetList.length > 10 ? { pageSize: 10 } : false}
      scroll={{ x: "100%" }}
    />
  )
  
} 